import React from 'react';
import Degree from './Degree';
import HighSchool from './HighSchool';
import Training from './Training';

function Education({ stud_id }) {

    return (
        <>
            <div id="employment_bx" className="job-bx bg-white m-b30 ">
                <Degree stud_id={stud_id} />
            </div>
            <div className="job-bx bg-white m-b30">
                <HighSchool stud_id={stud_id} />
            </div>
            <div className="job-bx bg-white m-b30">
                <Training stud_id={stud_id} />
            </div>
        </>
    );
}

export default Education;